module.exports = __webpack_public_path__ + "img/pic_brazil_01.fdeb9bbb.jpg";